import _ from 'lodash'
import {
  CreateRoleInput,
  RoleEntity,
  UpdateRoleInput,
} from '../../../../applications/ports/roleRepository'
import { createDelta } from '../../../../domain/value-object/ItemDeltaInputVO'
import { generateCode } from '../../../../utils/code'
import { generateUuid } from '../../../../utils/uuids'
import { ListRow } from '../../../containers/BulkSheetView/model'

/**
 * ロール定義のグリッド行データ型
 */
export interface RoleRow extends ListRow {
  code: string
  name: string
  description: string
  permissionPolicyUuids: string[]
  inUse: boolean
  editable: boolean
  displayOrder: number
}

const create = (
  existingCodes: string[],
  attachedByDefaultPolicyUuids: string[],
  displayOrder: number
): RoleRow => {
  return {
    uuid: generateUuid(),
    code: generateCode(existingCodes),
    name: '',
    description: '',
    permissionPolicyUuids: attachedByDefaultPolicyUuids,
    inUse: false,
    editable: true,
    displayOrder,
    added: true,
    edited: false,
  }
}
const fromRoleEntity = (role: RoleEntity): RoleRow => {
  return {
    uuid: role.uuid,
    code: role.code,
    name: role.name,
    description: role.description,
    permissionPolicyUuids: role.permissionPolicies.map(v => v.uuid),
    inUse: role.inUse,
    editable: role.editable,
    displayOrder: role.displayOrder,
    createdBy: role.createdBy,
    createdAt: role.createdAt,
    updatedBy: role.updatedBy,
    updatedAt: role.updatedAt,
    added: false,
    edited: false,
  }
}
const toCreateRoleInput = (
  row: RoleRow,
  displayOrder: number
): CreateRoleInput => {
  return {
    uuid: row.uuid,
    code: row.code,
    name: row.name,
    description: row.description,
    permissionPolicyUuids: row.permissionPolicyUuids,
    displayOrder,
  }
}
const toUpdateRoleInput = (
  row: RoleRow,
  original: RoleRow,
  displayOrder: number
): UpdateRoleInput => {
  return {
    uuid: row.uuid,
    name: createDelta(original.name, row.name),
    description: createDelta(original.description, row.description),
    permissionPolicyUuids: !_.isEqual(
      original.permissionPolicyUuids,
      row.permissionPolicyUuids
    )
      ? {
          oldValue: original.permissionPolicyUuids,
          newValue: row.permissionPolicyUuids,
        }
      : undefined,
    displayOrder: createDelta(original.displayOrder, displayOrder),
  }
}
const isEditable = (row: RoleRow) => {
  return row.editable
}
const isDeletable = (row: RoleRow) => {
  return row.editable && !row.inUse
}
export const roleRowService = {
  create,
  fromRoleEntity,
  toCreateRoleInput,
  toUpdateRoleInput,
  isEditable,
  isDeletable,
}
